module.exports = __webpack_public_path__ + "static/img/loader.a8c0b86.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/loader.gif
// module id = 12ci
// module chunks = 1